import { createSvgIcon } from "@mui/material";

export const Megaphone = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.05528 4.56196V16.4366C9.055 16.805 8.91658 17.1615 8.66441 17.4433C8.41223 17.7251 8.06248 17.9141 7.67678 17.977C7.29107 18.0399 6.89415 17.9727 6.55595 17.7872C6.21775 17.6016 5.95997 17.3097 5.82802 16.9628L3.80024 11.4958M3.80024 11.4958C2.99859 11.175 2.33932 10.6042 1.93399 9.87847C1.52867 9.15274 1.40219 8.31749 1.57595 7.51407C1.74971 6.71065 2.21305 5.98841 2.88755 5.46957C3.56205 4.95074 4.40629 4.66717 5.27739 4.66685H7.00767C10.88 4.66685 14.2093 3.56989 15.6666 2V14.4453C14.2093 12.8754 10.8809 11.7785 7.00767 11.7785H5.27739C4.76987 11.7792 4.26743 11.6824 3.80024 11.4958ZM15.6666 10.8895C16.4181 10.8895 17.1387 10.6085 17.6701 10.1084C18.2015 9.60827 18.5 8.92995 18.5 8.22265C18.5 7.51536 18.2015 6.83704 17.6701 6.33691C17.1387 5.83677 16.4181 5.5558 15.6666 5.5558V10.8895Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "Megaphone",
);
